/**
 * PDP sold-out state. Liquid paints the first pass; product.js confirms.
 */
(function (window) {
  var SOLD = 'Sold Out';
  var current = null;

  function buyRoot() {
    return document.querySelector('.la-buy');
  }

  function isSoldOut() {
    var root = buyRoot();
    return !!(root && root.classList.contains('is-sold-out'));
  }

  function labelEl(btn) {
    return btn.querySelector('[data-la-button-label], [data-la-sticky-label], .amp-button__label');
  }

  function setControl(btn, soldOut) {
    if (!btn) return;
    var label = labelEl(btn);
    if (label && !btn.dataset.ampOriginalHtml) {
      btn.dataset.ampOriginalHtml = label.innerHTML;
    }

    btn.disabled = soldOut;
    btn.classList.toggle('sold-out', soldOut);
    if (soldOut) {
      btn.setAttribute('aria-disabled', 'true');
      if (label) label.textContent = SOLD;
    } else {
      btn.removeAttribute('aria-disabled');
      if (label && btn.dataset.ampOriginalHtml) {
        label.innerHTML = btn.dataset.ampOriginalHtml;
      }
    }
  }

  function noteHTML() {
    var path = (window.location.pathname || '').toLowerCase();
    var links = [
      ['/products/testosterone-booster?view=testosterone-v-1', 'Testosterone Booster', 'testosterone'],
      ['/products/amp-science-creatine?view=creatine-v-1', 'Creatine Monohydrate', 'creatine'],
      ['/products/nitric-oxide-booster?view=nitric-oxide-v-1', 'Nitric Oxide Booster', 'nitric']
    ].filter(function (link) {
      return path.indexOf(link[2]) === -1;
    }).map(function (link) {
      return '<a href="' + link[0] + '">' + link[1] + '</a>';
    }).join('');

    return (
      '<div class="amp-sold-out" data-amp-sold-out-note data-amp-sold-out-injected="true" role="status" aria-live="polite">' +
        '<p class="amp-sold-out__badge">Sold Out</p>' +
        '<p class="amp-sold-out__copy">This item is currently out of stock. Shop another AMP Science formula while we restock.</p>' +
        (links ? '<p class="amp-sold-out__links">' + links + '</p>' : '') +
      '</div>'
    );
  }

  function ensureNote(soldOut) {
    var root = buyRoot();
    if (!root) return;
    var note = root.querySelector('[data-amp-sold-out-note]');
    if (soldOut && !note) {
      var title = root.querySelector('.la-buy__title');
      var holder = document.createElement('div');
      holder.innerHTML = noteHTML();
      var next = holder.firstElementChild;
      if (title && title.parentNode) {
        title.insertAdjacentElement('afterend', next);
      } else {
        root.insertBefore(next, root.firstChild);
      }
    }
    if (!soldOut && note && note.getAttribute('data-amp-sold-out-injected') === 'true') {
      note.remove();
    }
  }

  function set(soldOut) {
    soldOut = !!soldOut;
    current = soldOut;
    var root = buyRoot();
    if (root) root.classList.toggle('is-sold-out', soldOut);

    document.querySelectorAll('.la-buy__submit, [data-amp-buy-once], [data-la-atc-trigger]').forEach(function (btn) {
      setControl(btn, soldOut);
    });

    var bundle = document.querySelector('[data-amp-bundle]');
    if (bundle) {
      bundle.setAttribute('data-available', soldOut ? 'false' : 'true');
      bundle.querySelectorAll('input[type="radio"]').forEach(function (input) {
        input.disabled = soldOut;
      });
    }

    ensureNote(soldOut);
    return soldOut;
  }

  function syncFromProductJson() {
    var path = window.location.pathname.replace(/\/$/, '');
    if (path.indexOf('/products/') === -1) {
      if (isSoldOut()) set(true);
      return;
    }

    fetch(path + '.js')
      .then(function (response) { return response.json(); })
      .then(function (payload) {
        set(payload.available === false);
      })
      .catch(function () {
        if (isSoldOut()) set(true);
      });
  }

  window.ampSoldOut = {
    set: set,
    is: isSoldOut,
    sync: syncFromProductJson
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFromProductJson);
  } else {
    syncFromProductJson();
  }
})(window);
